import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Button, Typography, Chip } from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import MaterialTable from "material-table";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Formik } from 'formik';
import * as Yup from "yup";
import { groupBy } from 'lodash';
import CheckIcon from '@material-ui/icons/Check';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { LoadingComponent } from 'src/utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
}));

var screenCode = "INVOICEPAYMENTAPPROVAL"

export default function InvoicePaymentApprovalListing() {
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [gridArray, setGridArray] = useState([]);
  const [voucherTypes, setVoucherTypes] = useState();
  const [paymentIDData, setpaymentIDdata] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [generalJournalList, setGeneralJournalList] = useState({
    groupID: '0',
    factoryID: '0',
    transactionTypeID: '0',
    statusID: '0',
    referenceNumber: '',
    fromDate: new Date(),
    toDate: new Date()
  })

  const navigate = useNavigate();
  let encrypted = "";
  let encryptedgroupID = "";
  let encryptedfactoryID = ""

  const handleClickApprove = (referenceNumber) => {
    encrypted = btoa(referenceNumber.toString());
    encryptedgroupID = btoa(generalJournalList.groupID.toString());
    encryptedfactoryID = btoa(generalJournalList.factoryID.toString());
    sessionData();
    navigate('/app/invoicePaymentApproval/approve/' + encrypted + "/" + encryptedgroupID + "/" + encryptedfactoryID, {
      state: { generalJournalList }
    });
  }

  const handleClickView = (referenceNumber) => {
    encrypted = btoa(referenceNumber.toString());
    encryptedgroupID = btoa(generalJournalList.groupID.toString());
    encryptedfactoryID = btoa(generalJournalList.factoryID.toString());
    sessionData();
    navigate('/app/invoicePaymentApproval/view/' + encryptedgroupID + "/" + encryptedfactoryID + '/MA==/MA==/MA==/MA==/' + encrypted, {
      state: { generalJournalList }
    }); //MA== 0 value
  }

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isAddEnabled: false,
    isEditEnabled: false,
    isApproveEnabled: false
  });

  useEffect(() => {
    getPermissions();
    trackPromise(
      getGroupsForDropdown(),
      getVoucherTypeList()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesByGroupID()
    )
  }, [generalJournalList.groupID]);

  useEffect(() => {
    checkPendingCount();
  }, [gridArray]);

  useEffect(() => {
    setGridArray([])
  }, [generalJournalList.groupID, generalJournalList.factoryID, generalJournalList.fromDate, generalJournalList.toDate, generalJournalList.statusID, generalJournalList.referenceNumber]);

  useEffect(() => {
    if (paymentIDData !== null) {
      trackPromise(handleSearch())
    }
  }, [paymentIDData]);

  useEffect(() => {
    sessionStorage.removeItem('paymentInvoiceApproval-page-search-parameters-id');
  }, []);

  async function getPermissions() {

    const IDdata = JSON.parse(sessionStorage.getItem('paymentInvoiceApproval-page-search-parameters-id'));
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINVOICEPAYMENTAPPROVAL');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isAddEnabled = permissions.find(p => p.permissionCode == 'ADDEDITGURUGODALLAPAYMENTINVOICEAPPROVAL');
    var isEditEnabled = permissions.find(p => p.permissionCode == 'EDITGURUGODALLAPAYMENTINVOICEAPPROVAL');
    var isApproveEnabled = permissions.find(p => p.permissionCode == 'INVOICEPAYMENTAPPROVALAPPROVEBUTTONENABLED');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isAddEnabled: isAddEnabled !== undefined,
      isEditEnabled: isEditEnabled !== undefined,
      isApproveEnabled: isApproveEnabled !== undefined,
    });

    const isDefaultLoad = IDdata === null;
    if (isDefaultLoad) {
      setGeneralJournalList({
        ...generalJournalList,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      })
    }
    else {
      setGeneralJournalList({
        ...generalJournalList,
        groupID: parseInt(IDdata.groupID),
        factoryID: parseInt(IDdata.factoryID),
        transactionTypeID: parseInt(IDdata.transactionTypeID),
        statusID: parseInt(IDdata.statusID),
        referenceNumber: IDdata.referenceNumber,
        fromDate: IDdata.fromDate,
        toDate: IDdata.toDate
      })
      setVoucherTypes(IDdata.voucherTypes)
    }
    setpaymentIDdata(IDdata)
  }

  async function checkPendingCount() {
    let count = gridArray.filter(x => x.status == 1);
    setPendingCount(count.length);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(generalJournalList.groupID);
    setFactories(fac);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    voucherTypes.forEach(x => {
      if (x.screenCode == 'INVOICEPAYMENT') {
        setVoucherTypes(x.voucherTypeID)
      }
    });
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setGeneralJournalList({
      ...generalJournalList,
      [e.target.name]: value
    });
  }

  const handleDateChange1 = (date) => {
    setGeneralJournalList({
      ...generalJournalList,
      fromDate: date
    });
  };

  const handleDateChange = (date) => {
    setGeneralJournalList({
      ...generalJournalList,
      toDate: date
    });
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
        </Grid>
      </Grid>
    )
  }

  function clearData() {
    setGeneralJournalList({
      ...generalJournalList,
      groupID: generalJournalList.groupID,
      factoryID: generalJournalList.factoryID,
      transactionTypeID: '0',
      referenceNumber: '',
      statusID: '0',
      fromDate: new Date(),
      toDate: new Date()
    });
    setGridArray([]);
  }

  function sessionData() {
    let sessionModel = {
      groupID: generalJournalList.groupID,
      factoryID: generalJournalList.factoryID,
      transactionTypeID: generalJournalList.transactionTypeID,
      referenceNumber: generalJournalList.referenceNumber,
      fromDate: generalJournalList.fromDate,
      toDate: generalJournalList.toDate,
      statusID: generalJournalList.statusID,
      voucherTypes: voucherTypes
    }

    sessionStorage.setItem(
      'paymentInvoiceApproval-page-search-parameters-id', JSON.stringify(sessionModel)
    );
  }

  async function handleSearch() {
    const jList = await services.getGeneralJournalDetails(generalJournalList.groupID, generalJournalList.factoryID, generalJournalList.transactionTypeID, generalJournalList.referenceNumber, generalJournalList.fromDate, generalJournalList.toDate, generalJournalList.statusID);
    const groupByReferenceNumber = groupBy(jList, "referenceNumber");
    let keys = Object.keys(groupByReferenceNumber);
    let arrayCollection = [];
    keys.forEach(x => {
      arrayCollection.push(groupByReferenceNumber[x][0]);
    });
    let result = arrayCollection.filter((x) => x.voucherType === parseInt(voucherTypes));
    setGridArray(arrayCollection);
  }

  function statusCheck(data) {
    if (data == 1) { return "Pending" }
    else if (data == 2) { return "Approved" }
    else { return "Rejected" }
  }

  return (
    <Page
      className={classes.root}
      title="Invoice Payment Approval"
    >
      <Container maxWidth={false}>
        <Formik
          initialValues={{
            groupID: generalJournalList.groupID,
            factoryID: generalJournalList.factoryID,
          }}
          validationSchema={
            Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Select a group'),
              factoryID: Yup.number().required('Factory is required').min("1", 'Select a factory'),
            })
          }
          onSubmit={() => trackPromise(handleSearch())}
          enableReinitialize
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <LoadingComponent />
                <Card>
                  <CardHeader
                    title={cardTitle("Invoice Payment Approval")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{ marginBottom: "2rem" }}>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">Group  *</InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            helperText={touched.groupID && errors.groupID}
                            fullWidth
                            name="groupID"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={generalJournalList.groupID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">Factory *</InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            helperText={touched.factoryID && errors.factoryID}
                            fullWidth
                            name="factoryID"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={generalJournalList.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date</InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              fullWidth
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              margin="dense"
                              id="fromDate"
                              value={generalJournalList.fromDate}
                              onChange={(e) => {
                                handleDateChange1(e)
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                              autoOk
                              maxDate={new Date()}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date</InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              fullWidth
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              margin="dense"
                              id="toDate"
                              value={generalJournalList.toDate}
                              onChange={(e) => {
                                handleDateChange(e)
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                              autoOk
                              maxDate={new Date()}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="statusID">
                            Status
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.statusID && errors.statusID)}
                            fullWidth
                            helperText={touched.statusID && errors.statusID}
                            name="statusID"
                            onBlur={handleBlur}
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={generalJournalList.statusID}
                            variant="outlined"
                            id="statusID"
                          >
                            <MenuItem value="0">All</MenuItem>
                            <MenuItem value="1">Pending</MenuItem>
                            <MenuItem value="2">Approved</MenuItem>
                            <MenuItem value="3">Rejected</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="referenceNumber">Voucher Code</InputLabel>
                          <TextField
                            fullWidth
                            name="referenceNumber"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={generalJournalList.referenceNumber}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" flexDirection="row-reverse" p={2} >
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                        >
                          Search
                        </Button>
                        <div>&nbsp;</div>
                        <Button
                          color="primary"
                          type="reset"
                          variant="outlined"
                          onClick={() => clearData()}
                        >
                          Clear
                        </Button>
                      </Box>
                    </CardContent>
                    {pendingCount > 0 ?
                      <Grid container spacing={2}>
                        <Grid item xs={4} spacing={2}>
                          <Typography color="textSecondary" gutterBottom>
                            <Chip style={{ marginLeft: '1rem', backgroundColor: "#FFFDD0 ", color: 'black', }} alignContent="center"
                              icon={<AccessTimeIcon />}
                              label={"Pending count : " + pendingCount}
                              clickable
                              color="primary"
                            />
                          </Typography>
                        </Grid>
                      </Grid> : null}
                    {gridArray.length > 0 ?
                      <Box minWidth={1000} >
                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            { title: 'Date', field: 'date', render: rowdata => rowdata.date.split('T')[0] },
                            { title: 'Voucher Code', field: 'referenceNumber' },
                            { title: 'Description', field: 'description', render: rowData => rowData.description ? rowData.description : '-' },
                            {
                              title: 'Tran. Mode', field: 'modeoftransactionID',
                              lookup: {
                                3: 'Cheque',
                                7: 'Fund Transfer',
                                1: 'Cash',
                              },
                            },
                            {
                              title: 'Amount', field: 'credit',
                              render: rowdata => rowdata.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                              cellStyle: {
                                textAlign: 'right'
                              },
                              headerStyle: {
                                textAlign: 'right'
                              }
                            },
                            { title: 'Entered By', field: 'createdByName' },
                            { title: 'Supplier', field: 'supplierName', render: rowData => rowData.supplierName ? rowData.supplierName : '-' },
                            {
                              title: 'Status', field: 'status',
                              lookup: {
                                1: 'Pending',
                                2: 'Approved',
                                3: 'Rejected',
                              },
                              defaultSort: "desc",
                              render: rowData => {
                                if (rowData.status == 1) {
                                  return <div style={{ backgroundColor: "#FFFDD0", padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                                else if (rowData.status == 2) {
                                  return <div style={{ padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                                else {
                                  return <div style={{ padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                              },
                            },
                          ]}
                          data={gridArray}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1
                          }}
                          actions={[
                            rowData => (
                              {
                                hidden: !permissionList.isApproveEnabled || rowData.status != 1,
                                icon: CheckIcon,
                                tooltip: 'Approve',
                                onClick: (event, rowData) => handleClickApprove(rowData.referenceNumber),
                              }),
                            {
                              icon: VisibilityIcon,
                              tooltip: 'View',
                              onClick: (event, rowData) => handleClickView(rowData.referenceNumber)
                            }
                          ]}
                        />
                      </Box>
                      : null
                    }
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
};

